import Navbar from "./components/Navbar/Navbar";
import Home from "./components/Home/Home";
import Footer from "./components/Footer/Footer";

export default function App() {
	return (
		<div>
			<Navbar />
			<Home />
			<Footer />
		</div>
	);
}
